import Vue from 'vue'
import VueRouter from 'vue-router'
import ConfigurationsPage from '../views/Configurations'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Transactions',
    component: () => import("../views/Transactions/index.vue"),
  }, {
    path: '/error',
    name: 'Error',  
    component: () => import('../views/Error/index.vue')
  }, {
    path: '/configurations',
    name: 'Configurations',
    component: ConfigurationsPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
